<template>
    <v-btn
        :data-testid="dataTestid"
        :disabled="disabled"
        :loading="loading"
        :aria-label="getAriaLabel"
        :aria-disabled="ariaDisabled"
        :class="classes"
        :aria-describedby="ariaDescribedby"
        :small="$vuetify.breakpoint.smAndDown && allowSmall"
        rounded
        role="button"
        tabindex="0"
        :id="id"
        @click="nextStep()"
    >
        <span
            v-if="$vuetify.breakpoint.smAndDown && shortOnSmAndDown">
            <v-icon
                v-text="'fas fa-arrow-right'" />
        </span>
        <span v-else>
            <span>{{ getText }}</span>
            <v-icon
                small
                class="ml-2"
                v-text="'fas fa-arrow-right'" />
        </span>
    </v-btn>
</template>

<script>
export default {
    props: {
        id: { type: String, required: false, default: undefined },
        ariaLabel: { type: String, required: false, default: null },
        text: { type: String, required: false, default: null },
        ariaDisabled: { type: Boolean, required: false, default: false },
        ariaDescribedby: { type: String, required: false, default: undefined },
        disabled: { type: Boolean, required: false, default: false },
        loading: { type: Boolean, required: false, default: false },
        dataTestid: { type: String, required: false, default: '' },
        classes: { type: String, required: false, default: 'button-secondary-color button-continue-title' },
        shortOnSmAndDown: { type: Boolean, required: false, default: false },
        allowSmall: { type: Boolean, required: false, default: false }
    },
    computed: {
        getAriaLabel() {
            return this.ariaLabel || this.$t('base.accessibility.nextStep');
        },
        getText() {
            return this.text || this.$t('base.continue');
        },
    },
    methods: {
        /**
         * Emits next step event for parent component
         */
        nextStep() {
            this.$emit('nextStep');
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
